import type { FC } from 'react';
import type { AvatarProps } from '@george-labs.com/design-system/types/components/Image/Avatar';
import type { ContactInfoProps } from '@george-labs.com/design-system/types/components/ContactInfo/ContactInfo';
import { ContactInfo } from '@george-labs.com/design-system';

import { CONTACTS_AVATAR } from '@shared/core-ui-avatar';

import { SecureAvatar } from '../secure-avatar/SecureAvatar';

type Props = Omit<ContactInfoProps, 'icon' | 'imageUrl' | 'badgeColor' | 'badgeIcon'> &
    Pick<
        AvatarProps,
        | 'badgeColor'
        | 'badgeIcon'
        | 'icon'
        | 'imageUrl'
        | 'color'
        | 'backgroundColor'
        | 'variant'
        | 'initials'
    >;

export const SecureContactInfo: FC<Props> = ({
    icon,
    imageUrl,
    badgeIcon,
    badgeColor,
    initials,
    color = CONTACTS_AVATAR.COLOR,
    backgroundColor = CONTACTS_AVATAR.BACKGROUND_COLOR,
    variant = CONTACTS_AVATAR.VARIANT,
    ...contactInfoProps
}) => {
    return (
        <ContactInfo
            avatar={
                <SecureAvatar
                    initials={initials}
                    icon={icon}
                    imageUrl={imageUrl}
                    color={color}
                    backgroundColor={backgroundColor}
                    variant={variant}
                    badgeIcon={badgeIcon}
                    badgeColor={badgeColor}
                />
            }
            {...contactInfoProps}
        />
    );
};
